import React, { Component } from "react"
import PropTypes from "prop-types"
import InputField from "./InputField"

class InputFieldWithButton extends Component {
  static propTypes = {
    renderAppendToStep: PropTypes.func,
    doneCallback: PropTypes.func,
    type: PropTypes.string,
    labels: PropTypes.object,
    stepName: PropTypes.string,
    theme: PropTypes.object.isRequired,
    locale: PropTypes.string,
    selected: PropTypes.object,
    onSelectedUpdate: PropTypes.func,
    valuePropertyName: PropTypes.string,
  }

  state = {
    value:
      (this.props.valuePropertyName
        ? this.props.selected?.[this.props.valuePropertyName]
        : this.props.selected) || "",
  }

  done = () => {
    if (this.props.valuePropertyName) {
      this.props.doneCallback({
        [this.props.valuePropertyName]: this.state.value,
      })
    } else {
      this.props.doneCallback(this.state.value)
    }
  }

  valueChanged = (value) => {
    this.setState({ value })
    this.props.onSelectedUpdate &&
      this.props.onSelectedUpdate(this.props.stepName, value)
  }

  handleKeyDown = (e) => {
    if (e.key === "Enter") this.done()
  }

  componentDidMount() {
    this.props.renderAppendToStep(
      <button
        onClick={this.done}
        className={`main-cta uds-button primary full-width`}
      >
        {this.props.labels.continue}
      </button>
    )
  }

  componentWillUnmount() {
    this.props.renderAppendToStep(null)
  }

  render() {
    return (
      <InputField
        type={this.props.type || "text"}
        value={this.state.value}
        locale={this.props.locale}
        onChange={this.valueChanged}
        onKeyDown={this.handleKeyDown}
        openRight
        autoFocus
        inputPlaceholder={this.props.labels.placeholders[this.props.stepName]}
      />
    )
  }
}

export default InputFieldWithButton
